/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-undef */
import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { actions } from '@state/settings';
import { AlertDialog, Box } from '@versumstudios/ui';

export interface IWhatsNew {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
}

export const WhatsNew: FC<IWhatsNew> = ({ open, onOpenChange }) => {
  const dispatch = useDispatch();
  const version = process.env.CHANGELOG || '0.0.0';

  const handleOpenClose = (value: boolean) => {
    if (value === false) {
      dispatch({ type: actions.SETTINGS_CHANGE_CHANGELOG_VERSION, payload: version });
    }
    if (onOpenChange) {
      onOpenChange(value);
    }
  };

  return (
    <AlertDialog title="New on Versum" open={open} onOpenChange={handleOpenClose} canClose>
      <Box
        css={{
          width: '100%',
          flexDirection: 'column',
        }}
      >
        <Box
          css={{
            width: '100%',
            height: 300,
            flexDirection: 'column',
            justifyContent: 'space-between',
            borderRadius: 5,
            iframe: { height: '100%' },
          }}
        >
          <iframe
            title="Changelog"
            src={`https://versumstudios.github.io/changelog/log-${version}.html${
              (window as any).getTheme && `?theme=${(window as any).getTheme()}`
            }`}
            frameBorder="0"
            sandbox="allow-same-origin allow-scripts allow-popups"
          />
        </Box>
      </Box>
    </AlertDialog>
  );
};
